import { Empty } from '@arco-design/web-react';

export function ConstructionPage(props: { title: string }) {
  return <div className="portal-construction-page">
    <Empty description={<span>{props.title}正在开发建设中...</span>} />
  </div>;
}
